import React from 'react';
import SpadesSettingsFields from './SpadesSettingsFields';
import HeartsSettingsFields from './HeartsSettingsFields';
import GinSettingsFields from './GinSettingsFields';

function TableHostPanel({
  visible,
  watchersEnabled,
  siteBotsEnabled,
  settings,
  gameType = 'spades',
  lockGameSettings = false,
  hostSettingsLocked = false,
  onStartGame,
  onHostAction,
  floating = false,
}) {
  if (!visible) return null;

  const settingsReadOnly = lockGameSettings;
  const canStart = !lockGameSettings || hostSettingsLocked;
  const isHearts = gameType === 'hearts';
  const isGin = gameType === 'gin';

  const updateSettings = (next) => {
    if (isHearts) onHostAction('set-hearts-settings', next);
    else if (isGin) onHostAction('set-gin-settings', next);
    else onHostAction('set-spades-settings', next);
  };

  const panelClass = [
    'spades-bid-panel',
    'spades-host-panel',
    floating ? 'spades-bid-panel--float' : '',
  ].filter(Boolean).join(' ');

  const gameLabel = isHearts ? 'Hearts' : isGin ? 'Gin' : 'Spades';

  return (
    <div className={panelClass} role="region" aria-label="Host controls">
      <p className="spades-bid-prompt">
        Table host
        {' · '}
        {gameLabel}
      </p>

      {lockGameSettings && (
        <p className="spades-host-tournament-hint">
          Tournament lobby — settings are set by the lobby admin.
        </p>
      )}

      {isHearts ? (
        <HeartsSettingsFields
          settings={settings || {}}
          onChange={updateSettings}
          disabled={settingsReadOnly}
          idPrefix="table-host-hearts"
        />
      ) : isGin ? (
        <GinSettingsFields
          settings={settings || {}}
          onChange={updateSettings}
          disabled={settingsReadOnly}
          idPrefix="table-host-gin"
        />
      ) : (
        <SpadesSettingsFields
          settings={settings || {}}
          onChange={updateSettings}
          disabled={settingsReadOnly}
          idPrefix="table-host"
        />
      )}

      {lockGameSettings && (
        <label className="spades-host-setting spades-host-setting--check spades-host-lock-row">
          <input
            type="checkbox"
            checked={!!hostSettingsLocked}
            onChange={(e) => {
              onHostAction(e.target.checked ? 'lock-host-settings' : 'unlock-host-settings');
            }}
          />
          <span>Lock settings (required to start)</span>
        </label>
      )}

      <div className="spades-host-actions">
        <button
          type="button"
          className="spades-bid-btn spades-bid-btn--primary spades-host-btn--wide"
          onClick={onStartGame}
          disabled={!canStart}
          title={!canStart ? 'Lock settings before starting' : undefined}
        >
          Start game
        </button>
      </div>
      <div className="spades-host-toggles">
        <button
          type="button"
          className="spades-bid-btn spades-host-btn--toggle"
          onClick={() => onHostAction('set-watchers', { enabled: !watchersEnabled })}
        >
          {watchersEnabled ? 'Watching: on' : 'Watching: off'}
        </button>
        <button
          type="button"
          className="spades-bid-btn spades-host-btn--toggle"
          onClick={() => onHostAction('set-site-bots', { enabled: !siteBotsEnabled })}
        >
          {siteBotsEnabled ? 'Bots: on' : 'Bots: off'}
        </button>
      </div>
    </div>
  );
}

export default TableHostPanel;
